import { useImpuestoEmpresa } from "api/ImpuestoEmpresa.hook"
import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import { useDownloadFileContext } from "common/context/DownloadFileProvider"
import { LeyAntifraudeConfiguracionRequerida } from "feature-based/features/verifactu/organisms"
import { useUsuarioByCurrent } from "hooks/useUsuarioByCurrent"
import { useTranslation } from "react-i18next"
import { useHistory, useLocation } from "react-router-dom"
import FormCreacionDocumento from "../FormCreacionDocumento/FormCreacionDocumento"
import { TYPES_DOCUMENTOS } from "../FormCreacionDocumento/constant"

// TODO: selectores a eliminar tras la migracion: useFactura,newDocumentoSettingsSelector, newDocumento, newDocumentoSelectorDoc, newDocumentoSelector, albaranLogisticoSelector, globalSelector

const CreacionFactura = () => {
  const { state } = useLocation()
  const { t } = useTranslation()
  const history = useHistory()
  const downloadFile = useDownloadFileContext()
  const { activeCompany } = useUsuarioEmpresaActiva()
  const { usuarioByCurrent } = useUsuarioByCurrent()

  const empresaActiva = usuarioByCurrent?.empresaActiva

  const { impuestoEmpresa: tipoImpuestos } = useImpuestoEmpresa()

  const fieldValue = {
    id: activeCompany.id,
    logo: activeCompany.logo,
    logoAsBase64: activeCompany.logoAsBase64,
    ...(empresaActiva && { ...empresaActiva }),
  }

  return (
    <>
      <LeyAntifraudeConfiguracionRequerida configurarLeyAntifraudeDefinitivo />
      <FormCreacionDocumento
        type={
          state?.type === TYPES_DOCUMENTOS.FACTURA_RECTIFICATIVA
            ? TYPES_DOCUMENTOS.FACTURA_RECTIFICATIVA
            : TYPES_DOCUMENTOS.FACTURA
        }
        // @ts-expect-error TS(2322): Type '{ type: string; downloadFile: unknown; empre...
        downloadFile={downloadFile}
        empresaActiva={fieldValue}
        documento={state ?? null}
        tipoImpuestos={tipoImpuestos}
        t={t}
        history={history}
      />
    </>
  )
}

export default CreacionFactura
